import { AnimatePresence, motion } from 'framer-motion';
import { MapTrifold, SlidersHorizontal, Wrench, Stack } from 'phosphor-react';

const tabs = [
  { id: 'resources', label: 'الموارد', icon: Stack, emoji: '🪨' },
  { id: 'services', label: 'الخدمات', icon: MapTrifold, emoji: '🛰️' },
  { id: 'basemap', label: 'الخلفيات', icon: SlidersHorizontal, emoji: '🌈' },
  { id: 'tools', label: 'الأدوات', icon: Wrench, emoji: '🎨' }
];

export const MapSidebar = ({
  open,
  onToggle,
  activeTab,
  onChangeTab,
  renderResources,
  renderServices,
  renderBasemap,
  renderTools,
  footer
}) => {
  const panelVariants = {
    closed: { x: 420, opacity: 0 },
    open: { x: 0, opacity: 1 }
  };

  const contentByTab = {
    resources: renderResources,
    services: renderServices,
    basemap: renderBasemap,
    tools: renderTools
  };

  return (
    <>
      <div className="absolute top-4 right-4 z-[1100] hidden md:block">
        <motion.div
          initial={false}
          animate={open ? 'open' : 'closed'}
          variants={panelVariants}
          transition={{ type: 'spring', stiffness: 260, damping: 26 }}
          className="glass-panel w-[360px] max-h-[calc(100vh-120px)] overflow-hidden map-sidebar-shell"
        >
          <div className="p-3 border-b border-white/40 bg-white/50 map-sidebar-header">
            <div className="flex items-center justify-between">
              <p className="font-black text-gray-900">لوحة الاستكشاف</p>
              <button
                type="button"
                onClick={onToggle}
                className="chip"
              >
                {open ? 'إخفاء' : 'إظهار'}
              </button>
            </div>

            <div className="mt-3 grid grid-cols-4 gap-2">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => onChangeTab(tab.id)}
                    className={`map-tab-btn ${isActive ? 'map-tab-btn-active' : 'map-tab-btn-idle'}`}
                  >
                    <span className="text-base leading-none">{tab.emoji}</span>
                    <Icon size={18} weight={isActive ? 'fill' : 'regular'} />
                    <span>{tab.label}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="p-3 overflow-y-auto max-h-[calc(100vh-240px)]">
            {contentByTab[activeTab]?.()}
          </div>

          {footer && (
            <div className="p-3 border-t border-white/40 bg-white/50 map-sidebar-header">
              {footer}
            </div>
          )}
        </motion.div>

        {!open && (
          <button
            type="button"
            onClick={onToggle}
            className="mt-3 glass-panel px-4 py-3 font-black text-gray-900 map-open-btn"
          >
            افتح لوحة الاستكشاف
          </button>
        )}
      </div>

      {/* Mobile: bottom sheet */}
      <div className="md:hidden absolute bottom-24 left-4 right-4 z-[1100]">
        <AnimatePresence initial={false}>
          {open ? (
            <motion.div
              key="sheet"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 30, opacity: 0 }}
              transition={{ duration: 0.22 }}
              className="glass-panel overflow-hidden map-sidebar-shell"
            >
              <div className="p-3 border-b border-white/40 bg-white/50 flex items-center justify-between map-sidebar-header">
                <p className="font-black text-gray-900">لوحة الاستكشاف</p>
                <button type="button" onClick={onToggle} className="chip">إغلاق</button>
              </div>

              <div className="p-3 grid grid-cols-4 gap-2">
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => onChangeTab(tab.id)}
                      className={`map-tab-btn text-[11px] ${isActive ? 'map-tab-btn-active' : 'map-tab-btn-idle'}`}
                    >
                      <span className="text-base leading-none">{tab.emoji}</span>
                      <Icon size={18} weight={isActive ? 'fill' : 'regular'} />
                      <span>{tab.label}</span>
                    </button>
                  );
                })}
              </div>

              <div className="p-3 overflow-y-auto max-h-[55vh]">
                {contentByTab[activeTab]?.()}
              </div>

              {footer && (
                <div className="p-3 border-t border-white/40 bg-white/50 map-sidebar-header">
                  {footer}
                </div>
              )}
            </motion.div>
          ) : (
            <motion.button
              key="open"
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 10, opacity: 0 }}
              transition={{ duration: 0.2 }}
              type="button"
              onClick={onToggle}
              className="w-full glass-panel px-4 py-3 font-black text-gray-900 map-open-btn"
            >
              افتح لوحة الاستكشاف
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};
